// 中文路由

import Layout from "@views/layout";
import Other from "@views/layout/other";

const zhRouter = [
  {
    path: "/",
    name: "DASHBOARD",
    component: Layout,
    redirect: { name: "DASHBOARD_LIST" },
    children: [
      {
        path: "/cn/index/index",
        name: "DASHBOARD_LIST",
        meta: { title: "首页-OceanClub技术社区", personname: "DASHBOARD_LIST" },
        component: () => import("@views/home/index"),
        // component: () => import('@views/dashboard/index'),
      },
    ],
  },
  // 活动 active
  {
    path: "/",
    name: "ACTIVE",
    component: Layout,
    redirect: { name: "ACTIVE_LIST" },
    children: [
      {
        path: "/cn/activity/index",
        name: "ACTIVE_LIST",
        meta: { title: "活动-OceanClub技术社区", personname: "ACTIVE_LIST" },
        component: () => import("@views/active/index"),
      },
    ],
  },
  // 赞助
  {
    path: "/",
    name: "STATIONED",
    component: Layout,
    redirect: { name: "STATIONED_LIST" },
    children: [
      {
        path: "/cn/stationed/index",
        name: "STATIONED_LIST",
        meta: { title: "专家-OceanClub技术社区", personname: "STATIONED_LIST" },
        component: () => import("@views/stationed/index"),
      },
      {
        path: "/cn/stationed/info/:id/:tab/:type",
        name: "STATIONED_INFO",
        meta: { title: "专家-OceanClub技术社区", personname: "STATIONED_LIST" },
        component: () => import("@views/stationed/info"),
      },
      {
        path: "/cn/stationed/application",
        name: "STATIONED_APPLICATION",
        meta: {
          title: "专家-OceanClub技术社区",
          personname: "STATIONED_LIST",
          hideFooter: true,
        },
        component: () => import("@views/stationed/application"),
      },
      {
        path: "/cn/stationed/mvp",
        name: "STATIONED_MVPS",
        meta: {
          title: "专家-OceanClub技术社区",
          personname: "STATIONED_LIST",
          hideFooter: true,
        },
        component: () => import("@views/mvp/index"),
      },
    ],
  },
  // 活动详情 active
  {
    path: "/",
    name: "ACTIVEINFO",
    component: Layout,
    redirect: { name: "ACTIVEINFO_LIST" },
    children: [
      {
        path: "/cn/activity/info/:id",
        name: "ACTIVE_LIST",
        meta: { title: "活动-OceanClub技术社区", personname: "ACTIVE_LIST" },
        component: () => import("@views/activeInfo/index"),
      },
    ],
  },
  // 积分 points
  {
    path: "/",
    name: "POINTS",
    component: Layout,
    redirect: { name: "POINTS" },
    children: [
      {
        path: "/cn/points/ranking/:ta_id",
        name: "POINTS_RANKING",
        meta: { title: "活动-积分排行榜单-OceanClub技术社区", personname: "POINTS_RANKING" },
        component: () => import("@views/points/ranking"),
      },
      {
        path: "/cn/points/detail/:ta_id",
        name: "POINTS_DETAIL",
        meta: { title: "活动-积分明细-OceanClub技术社区", personname: "POINTS_DETAIL" },
        component: () => import("@views/points/detail"),
      },
    ],
  },
  // 挑战赛 challenge
  {
    path: "/",
    name: "CHALLENGE",
    component: Layout,
    redirect: { name: "CHALLENGE" },
    children: [
      {
        path: "/cn/challenge/info/:id",
        name: "CHALLENGE_LIST",
        meta: { title: "活动-OceanClub技术社区", personname: "ACTIVE_LIST" },
        component: () => import("@views/challenge/index"),
      },
      {
        path: "/cn/challenge/daily/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_DAILY",
        meta: { title: "活动-每日一答-答题-OceanClub技术社区", personname: "CHALLENGE_DAILY" },
        component: () => import("@views/challenge/daily"),
      },
      {
        path: "/cn/challenge/weekly/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_WEEKLY",
        meta: { title: "活动-每周一答-答题-OceanClub技术社区", personname: "CHALLENGE_WEEKLY" },
        component: () => import("@views/challenge/weekly"),
      },
      {
        path: "/cn/challenge/lecture/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_LECTURE",
        meta: { title: "活动-申请大讲堂授课-OceanClub技术社区", personname: "CHALLENGE_LECTURE" },
        component: () => import("@views/challenge/lecture"),
      },
      {
        path: "/cn/challenge/circlepart/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_CIRCLEPART",
        meta: { title: "活动-圈子活动参与证明-OceanClub技术社区", personname: "CHALLENGE_CIRCLEPART" },
        component: () => import("@views/challenge/circlepart"),
      },
      {
        path: "/cn/challenge/circlelecture/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_CIRCLELECTURE",
        meta: { title: "活动-圈子演讲参与证明-OceanClub技术社区", personname: "CHALLENGE_CIRCLELECTURE" },
        component: () => import("@views/challenge/circlelecture"),
      },
      {
        path: "/cn/challenge/technicalarticles/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_TECHNICALARTICLES",
        meta: { title: "活动-撰写技术文章-OceanClub技术社区", personname: "CHALLENGE_TECHNICALARTICLES" },
        component: () => import("@views/challenge/technicalarticles"),
      },
      {
        path: "/cn/challenge/projectorder/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_PROJECTORDER",
        meta: { title: "活动-提交项目下单证明 -OceanClub技术社区", personname: "CHALLENGE_PROJECTORDER" },
        component: () => import("@views/challenge/projectorder"),
      },
      {
        path: "/cn/challenge/certificate/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_CERTIFICATE",
        meta: { title: "活动-HCSX/HCIX证书 -OceanClub技术社区", personname: "CHALLENGE_CERTIFICATE" },
        component: () => import("@views/challenge/certificate"),
      },

    ],
  },
  /* 问卷 */
  {
    path: "/cn/questionnaire/:ta_id",
    name: "QUESTIONNAIRE",
    meta: { title: "问卷-OceanClub技术社区", personname: "QUESTIONNAIRE" },
    component: () => import("@views/questionnaire/index"),
  },
  // 话题
  {
    path: "/",
    name: "SUBJECT",
    component: Layout,
    redirect: { name: 'SUBJECT_LIST' },
    children: [
      {
        path: "/cn/subject/list",
        name: "SUBJECT_LIST",
        meta: { title: "话题-OceanClub技术社区", personname: 'SUBJECT_LIST' },
        component: () => import('@views/subject/index'),
      },
      {
        path: "/cn/subject/info/:id",
        name: "SUBJECT_INFO",
        meta: { title: "话题-OceanClub技术社区", personname: 'SUBJECT_LIST' },
        component: () => import('@views/subject/info'),
      },
      {
        // 主持人专区
        path: "/cn/subject/hostZone",
        name: "SUBJECT_HOSTZONE",
        meta: { title: "话题-OceanClub技术社区", personname: 'SUBJECT_LIST' },
        component: () => import('@views/subject/hostZone'),
      },
      {
        // 相关活动列表
        path: "/cn/subject/activeList/:id",
        name: "SUBJECT_ACTIVELIST",
        meta: { title: "话题-OceanClub技术社区", personname: 'SUBJECT_LIST' },
        component: () => import('@views/subject/activeList'),
      },
    ]
  },
  // 讨论
  {
    path: "/",
    name: "DISCUSS",
    component: Layout,
    redirect: { name: 'DISCUSS_LIST' },
    children: [
      {
        path: "/cn/discuss/list",
        name: "DISCUSS_LIST",
        meta: { title: "讨论-OceanClub技术社区", personname: 'DISCUSS_LIST' },
        component: () => import('@views/discuss/index'),
      },
      {
        path: "/cn/discuss/moderatorzone",
        name: "DISCUSS_MODERATORZONE",
        meta: { title: "讨论-OceanClub技术社区", personname: 'DISCUSS_LIST' },
        component: () => import('@views/discuss/moderatorZone'),
      }, {
        path: "/cn/discuss/info/:id/:is_preview?",
        name: "DISCUSS_INFO",
        meta: { title: "讨论-OceanClub技术社区", personname: 'DISCUSS_LIST' },
        component: () => import('@views/discuss/info'),
      },

    ]
  }, {
    // 签到报名
    path: "/",
    name: "SIGNREGIST",
    component: Other,
    redirect: { name: 'SIGNREGIST_LIST' },
    children: [
      {
        path: "/cn/signregist/list/:ta_id/:sign_type/:view_type",
        name: "SIGNREGIST_LIST",
        meta: { title: "注册报名-OceanClub技术社区", personname: 'SIGNREGIST_LIST' },
        component: () => import('@views/signregist/index'),
      },
    ]
  },
  // 登录
  {
    path: "/cn/login/:logintype?/:loginTab?",
    name: "LOGIN",
    meta: { title: "登录-OceanClub技术社区", personname: "LOGIN" },
    component: () => import('@views/login/index'),
  },
  // 个人信息完善
  {
    path: "/cn/information",
    name: "INFORMATION",
    meta: { title: "个人信息完善-OceanClub技术社区", personname: "INFORMATION" },
    component: () => import('@views/login/information'),
  },
  // 找回密码
  {
    path: "/cn/forget",
    name: "FORGET",
    meta: { title: "找回密码-OceanClub技术社区", personname: "FORGET" },
    component: () => import('@views/login/forget'),
  },

  // 全局搜索
  {
    path: "/",
    name: "SEARCH",
    component: Layout,
    redirect: { name: 'SEARCH_LIST' },
    children: [
      {
        path: "/cn/search/:search_key?",
        name: "SEARCH_LIST",
        meta: { title: "搜索-OceanClub技术社区", personname: "SEARCH" },
        component: () => import("@views/search/index"),
      }
    ]
  },
  // 个人中心
  {
    path: "/",
    name: "USER",
    component: Layout,
    redirect: { name: 'USER_LIST' },
    children: [
      {
        path: "/cn/userinfo",
        name: "SEARCH_LIST",
        meta: { title: "个人中心-OceanClub技术社区", personname: "USER" },
        component: () => import("@views/user/index"),
      }
    ]
  },
  // 个人中心 personal
  {
    path: "/",
    name: "PERSONAL",
    component: Layout,
    redirect: { name: 'PERSONAL_LIST' },
    children: [
      {
        path: "/cn/personal",
        name: "PERSONAL_LIST",
        meta: { title: "个人中心-OceanClub技术社区", personname: "PERSONAL" },
        component: () => import("@views/personal/index"),
      }
    ]
  },
  // 期刊
  {
    path: "/",
    name: "JOURNAL",
    component: Layout,
    redirect: { name: 'JOURNAL_LIST' },
    children: [
      {
        path: "/cn/journal/index",
        name: "JOURNAL_LIST",
        meta: { title: "期刊-OceanClub技术社区", personname: "JOURNAL_LIST" },
        component: () => import("@views/journal/index"),
      },
      {
        path: "/cn/journal/info/:id",
        name: "JOURNAL_LIST",
        meta: { title: "期刊-OceanClub技术社区", personname: "JOURNAL_LIST" },
        component: () => import("@views/journal/info"),
      }
    ]
  },
  // 积分商城
  {
    path: "/",
    name: "POINTMALL",
    component: Layout,
    redirect: { name: 'POINTMALL_LIST' },
    children: [
        {
          path: "/cn/pointmall",
          name: "POINTMALL_LIST",
          meta: {title: "积分商城-OceanClub技术社区", personname: "POINTMALL_LIST"},
          component: () => import("@views/pointmall/index.vue"),
        },
        {
          path: "/cn/pointmall/info/:id",
          name: "POINTMALL_INFO",
          meta: {title: "积分商城详情-OceanClub技术社区", personname: "POINTMALL_LIST"},
          component: () => import("@views/pointmall/info.vue"),
        },
        {
          path: "/cn/pointmall/exchange/:id",
          name: "POINTMALL_EXCHANGE",
          meta: {title: "积分商城兑换-OceanClub技术社区", personname: "POINTMALL_LIST"},
          component: () => import("@views/pointmall/exchange.vue"),
        },
    ]
  },

  // 关于我们
  {
    path: "/",
    name: "ABOUT",
    component: Layout,
    redirect: { name: 'ABOUT_LIST' },
    children: [
        {
          path: "/cn/about",
          name: "ABOUT_LIST",
          meta: {title: "关于我们-OceanClub技术社区", personname: "ABOUT_LIST"},
          component: () => import("@views/about/index.vue"),
        }
    ]
  },
  // 合作
  {
    path: "/",
    name: "COOPERATE",
    component: Layout,
    redirect: { name: 'COOPERATE_LIST' },
    children: [
      {
        path: "/cn/cooperate/index",
        name: "COOPERATE_LIST",
        meta: { title: "合作-OceanClub技术社区", personname: "COOPERATE_LIST" },
        component: () => import("@views/cooperate/index"),
      },
      {
        path: "/cn/cooperate/info/:id",
        name: "COOPERATE_INFO",
        meta: { title: "合作-OceanClub技术社区", personname: "COOPERATE_INFO" },
        component: () => import("@views/cooperate/info"),
      }
    ]
  },
  // 抽奖落地页
  {
    path: "/cn/rafflelandingpage",
    name: "RAFFLELANDINGPAGE",
    meta: { title: "抽奖-OceanClub技术社区", personname: "RAFFLELANDINGPAGE" },
    component: () => import('@views/raffle/index'),
  },
];


export default zhRouter;
